import { parseApiResponse, getApiErrorMessage } from '@/shared/utils/apiResponse';
import type { AgentValidation, FlowValidationProblem } from '../../types/negotiationAgents';
export async function readAgentResponse<T>(response: Response): Promise<T> {
  if (response.ok) return parseApiResponse<T>(response);
  const payload: unknown = await response.json().catch(() => null);
  const record =
    typeof payload === 'object' && payload !== null ? (payload as Record<string, unknown>) : {};
  const error =
    typeof record.error === 'object' && record.error !== null
      ? (record.error as Record<string, unknown>)
      : record;
  const problem: FlowValidationProblem = {
    message: getApiErrorMessage(payload, `HTTP ${response.status}`),
    code: typeof error.code === 'string' ? error.code : 'REQUEST_FAILED',
    status: response.status,
  };
  if (typeof error.details === 'object' && error.details !== null)
    problem.details = error.details as AgentValidation;
  throw problem;
}

export function toAgentProblem(error: unknown): FlowValidationProblem {
  if (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof error.message === 'string'
  ) {
    return {
      code: 'code' in error && typeof error.code === 'string' ? error.code : 'REQUEST_FAILED',
      message: error.message,
      ...('status' in error && typeof error.status === 'number' ? { status: error.status } : {}),
      ...('details' in error ? { details: error.details as AgentValidation } : {}),
    };
  }
  return {
    code: 'REQUEST_FAILED',
    message: typeof error === 'string' ? error : 'Não foi possível concluir a operação.',
  };
}
